import { WithAccountId } from '@mews-commander/types';
import { CreatePaymentPlanFormStep } from './types';
import { PlanDetailsFormFields } from './fields/PlanDetailsFormFields';
import { PaymentPlanReservationFormContent } from './PaymentPlanReservationFormContent';
import { FirstPaymentFormFields } from './fields/FirstPaymentFormFields';
import { CreatePaymentPlanSummary } from './CreatePaymentPlanSummary';

export const CreatePaymentPlanDialogFormContent = ({
    step,
    accountId,
}: { step: CreatePaymentPlanFormStep } & WithAccountId) => {
    switch (step) {
        case 'planDetails':
            return <PlanDetailsFormFields accountId={accountId} />;
        case 'firstPayment':
            return (
                <PaymentPlanReservationFormContent
                    accountId={accountId}
                    renderContent={({ reservation }) => <FirstPaymentFormFields reservation={reservation} />}
                />
            );
        case 'summary':
            return (
                <PaymentPlanReservationFormContent
                    accountId={accountId}
                    renderContent={({ reservation }) => (
                        <CreatePaymentPlanSummary reservation={reservation} accountId={accountId} />
                    )}
                />
            );
    }
};
